import type { Latest, Tick1m, Signal } from "../functions/_lib/types";
const j = async <T>(url: string): Promise<T> => {
  const r = await fetch(url);
  if (!r.ok) throw new Error(`${url} -> HTTP ${r.status}`);
  return r.json() as Promise<T>;
};
export const getLatest = () => j<Latest | null>("/api/latest");
export const getSeries = (res: "1m", from: number, to: number) =>
  j<Tick1m[]>(`/api/series?res=${res}&from=${from}&to=${to}`);
export const getSignals = (limit = 100) => j<Signal[]>(`/api/signals?limit=${limit}`);
export const getKrw = () => j<{ ts: number; close: number }[]>("/api/krw");
